// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs__list {
  border-bottom: 1px solid #eee;
}
.tabs__list-button {
  transform: translateY(1px);
  padding: 8px 16px;
  border: 1px solid transparent;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  color: #0055ff;
}
.tabs__list-button.active {
  border: 1px solid #eee;
  border-bottom-color: #fff;
  color: #000000;
}
.backdrop {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  inset: 0;
  width: 100%;
  height: 100vh;
  display: block;
}

.modal {
  position: fixed;
  background-color: #ffffff;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  max-height: calc(100vh - 8px);
  min-width: 400px;
  max-width: 600px;
  overflow: auto;
  padding: 32px 24px;
}
.modal__close {
  position: absolute;
  top: 16px;
  right: 16px;
}

.item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 4px 16px;
}
.item-row:hover {
  background-color: #f5f5f5;
}
.item-row__links-container {
  display: flex;
  gap: 16px;
}
.item-row__link {
  color: #0055ff;
  font-weight: 500;
  text-decoration: underline;
}
.item-row__delete {
  border: 0;
  padding: 0;
  margin: 0;
  color: #aaaaaa;
}
.item-row__delete:hover {
  color: #000000;
}
.item-row__delete-icon {
  width: 12px;
}

.app-button {
  display: inline-flex;
  align-items: center;
  gap: 24px;
  border: 1px solid rgba(238, 238, 238, 0.9333333333);
  border-bottom-width: 2px;
  padding: 20px 32px;
  font-weight: 500;
  font-size: 24px;
}
.app-button:hover {
  border-bottom-width: 1px;
  transform: translateY(1px);
}
.app-button__img {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

h1.heading {
  font-size: 32px;
  font-weight: 600;
}

h2.heading {
  font-size: 24px;
  font-weight: 600;
}

h3.heading {
  font-size: 20px;
  font-weight: 600;
}

h4.heading {
  font-size: 18px;
  font-weight: 600;
}

h5.heading {
  font-size: 16px;
  font-weight: 600;
}

h6.heading {
  font-size: 14px;
  font-weight: 600;
}

.file-input {
  display: flex;
}
.file-input__input {
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
}
.file-input__label {
  cursor: pointer;
  flex: 1 1;
  border: 1px dashed #ddd;
  color: #333;
  border-radius: 8px;
  text-align: center;
  height: 75px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.spinner {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 3px solid #000000;
  border-bottom: 3px solid transparent;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.modal-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.modal-form__store-inputs {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}
.modal-form__store-inputs > div {
  flex: 1 1;
}
.modal-form__button {
  padding: 8px 16px;
  border: 1px solid #eee;
  border-radius: 8px;
}

.are-you-sure-modal {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.are-you-sure-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.home-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.home-page__intro-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.home-page__header {
  font-size: 32px;
  font-weight: 600;
}
.home-page__paragraph {
  font-size: 20px;
  line-height: 125%;
  max-width: 600px;
}
.home-page__apps-container {
  border-top: 1px solid #eee;
  padding-block: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
.home-page__button {
  border: 1px solid rgba(238, 238, 238, 0.9333333333);
  border-bottom-width: 2px;
  padding: 20px 32px;
  font-weight: 500;
  font-size: 24px;
}
.home-page__button:hover {
  border-bottom-width: 1px;
  transform: translateY(1px);
}

.app-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.app-page__intro-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.app-page__header {
  font-size: 32px;
  font-weight: 600;
}
.app-page__sub-header {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
}
.app-page__paragraph {
  font-size: 20px;
  line-height: 125%;
  max-width: 600px;
}
.app-page__how-to-install {
  font-weight: 600;
  text-decoration: underline;
}
.app-page__grid {
  padding-block: 24px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
}
@media (min-width: 768px) {
  .app-page__grid {
    grid-template-columns: 1fr 1fr;
  }
}
.app-page__sub-versions {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.app-page__apps-container {
  border-top: 1px solid #eee;
  display: flex;
  gap: 24px;
}
.app-page__button {
  border: 1px solid rgba(238, 238, 238, 0.9333333333);
  border-bottom-width: 2px;
  padding: 20px 32px;
  font-weight: 500;
  font-size: 24px;
}
.app-page__button:hover {
  border-bottom-width: 1px;
  transform: translateY(1px);
}
.app-page__lastest {
  background-color: #0055ff !important;
}
.app-page__version-button {
  color: #0055ff;
  font-weight: 500;
  text-decoration: underline;
}
.app-page__app-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.app-page__list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.admin-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
}

.admin-user-form {
  padding: 24px;
  border: 1px solid #eee;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
}

.how-to-install {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.how-to-install__link-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.how-to-install__link {
  color: #0055ff;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/Tabs/_tabs.scss","webpack://./src/scss/main.scss","webpack://./src/components/Modal/_modal.scss","webpack://./src/components/ItemRow/_item-row.scss","webpack://./src/components/AppButton/_app-button.scss","webpack://./src/components/Heading/_heading.scss","webpack://./src/components/FileInput/_file-input.scss","webpack://./src/components/Spinner/_spinner.scss","webpack://./src/modals/_modal-form.scss","webpack://./src/modals/_are-you-sure-model.scss","webpack://./src/pages/home/_homePage.scss","webpack://./src/pages/apps/_appPage.scss","webpack://./src/pages/admin/_admin-suer-form.scss","webpack://./src/pages/howToInstall/_how-to-install.scss"],"names":[],"mappings":"AACE;EACE,6BAAA;ACAJ;ADGE;EACE,0BAAA;EACA,iBAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,cAAA;ACDJ;ADGI;EACE,sBAAA;EACA,yBAAA;EACA,cAAA;ACDN;ACfA;EACE,eAAA;EACA,oCAAA;EAEA,QAAA;EAEA,WAAA;EACA,aAAA;EACA,cAAA;ADeF;;ACZA;EACE,eAAA;EAEA,yBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EAEA,kBAAA;EAEA,6BAAA;EAEA,gBAAA;EACA,gBAAA;EACA,cAAA;EAEA,kBAAA;ADUF;ACRE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;ADUJ;;AE1CA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;AF6CF;AE3CE;EACE,yBAAA;AF6CJ;AE1CE;EACE,aAAA;EACA,SAAA;AF4CJ;AEzCE;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;AF2CJ;AExCE;EACE,SAAA;EACA,UAAA;EACA,SAAA;EAEA,cAAA;AFyCJ;AEvCI;EACE,cAAA;AFyCN;AErCE;EACE,WAAA;AFuCJ;;AG3EA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EAEA,mDAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AH6EF;AG3EE;EACE,wBAAA;EACA,0BAAA;AH6EJ;AG1EE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AH4EJ;;AI/FA;EACE,eAAA;EACA,gBAAA;AJkGF;;AI/FA;EACE,eAAA;EACA,gBAAA;AJkGF;;AI/FA;EACE,eAAA;EACA,gBAAA;AJkGF;;AI/FA;EACE,eAAA;EACA,gBAAA;AJkGF;;AI/FA;EACE,eAAA;EACA,gBAAA;AJkGF;;AI/FA;EACE,eAAA;EACA,gBAAA;AJkGF;;AK7HA;EACE,aAAA;ALgIF;AK9HE;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;ALgIJ;AK7HE;EACE,eAAA;EAEA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AL6HJ;AMpJA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;EACA,kCAAA;ANsJF;;AMnJA;EACE;IACE,uBAAA;ENsJF;EMpJA;IACE,yBAAA;ENsJF;AACF;AOrKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;APuKF;AOrKE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;APuKJ;AOrKI;EACE,SAAA;APuKN;AOnKE;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;APqKJ;;AQvLA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AR0LJ;AQxLI;EACI,aAAA;EACA,yBAAA;EACA,QAAA;AR0LR;;ASlMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ATqMF;ASnME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ATqMJ;ASlME;EACE,eAAA;EACA,gBAAA;AToMJ;ASjME;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;ATmMJ;AShME;EACE,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;ATkMJ;AS/LE;EACE,mDAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;ATiMJ;AS/LI;EACE,wBAAA;EACA,0BAAA;ATiMN;;AUxOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AV2OF;AUzOE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AV2OJ;AUxOE;EACE,eAAA;EACA,gBAAA;AV0OJ;AUvOE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AVyOJ;AUtOE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AVwOJ;AUrOE;EACE,gBAAA;EACA,0BAAA;AVuOJ;AUpOE;EACE,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,SAAA;AVsOJ;AUpOI;EANF;IAOI,8BAAA;EVuOJ;AACF;AUpOE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AVsOJ;AUnOE;EACE,0BAAA;EACA,aAAA;EAEA,SAAA;AVoOJ;AUjOE;EACE,mDAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AVmOJ;AUjOI;EACE,wBAAA;EACA,0BAAA;AVmON;AU/NE;EACE,oCAAA;AViOJ;AU9NE;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;AVgOJ;AU7NE;EACE,aAAA;EACA,sBAAA;EAEA,SAAA;EACA,WAAA;AV8NJ;AU3NE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AV6NJ;;AWxTA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AX2TF;;AWzTA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AX4TF;;AYxUA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AZ2UF;AYzUE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AZ2UJ;AYxUE;EACE,cAAA;EACA,0BAAA;AZ0UJ","sourcesContent":[".tabs {\n  &__list {\n    border-bottom: 1px solid #eee;\n  }\n\n  &__list-button {\n    transform: translateY(1px);\n    padding: 8px 16px;\n    border: 1px solid transparent;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    color: #0055ff;\n\n    &.active {\n      border: 1px solid #eee;\n      border-bottom-color: #fff;\n      color: #000000;\n    }\n  }\n\n  &__content {\n  }\n}\n",".tabs__list {\n  border-bottom: 1px solid #eee;\n}\n.tabs__list-button {\n  transform: translateY(1px);\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  color: #0055ff;\n}\n.tabs__list-button.active {\n  border: 1px solid #eee;\n  border-bottom-color: #fff;\n  color: #000000;\n}\n.backdrop {\n  position: fixed;\n  background-color: rgba(0, 0, 0, 0.5);\n  inset: 0;\n  width: 100%;\n  height: 100vh;\n  display: block;\n}\n\n.modal {\n  position: fixed;\n  background-color: #ffffff;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 8px;\n  max-height: calc(100vh - 8px);\n  min-width: 400px;\n  max-width: 600px;\n  overflow: auto;\n  padding: 32px 24px;\n}\n.modal__close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n}\n\n.item-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 4px 16px;\n}\n.item-row:hover {\n  background-color: #f5f5f5;\n}\n.item-row__links-container {\n  display: flex;\n  gap: 16px;\n}\n.item-row__link {\n  color: #0055ff;\n  font-weight: 500;\n  text-decoration: underline;\n}\n.item-row__delete {\n  border: 0;\n  padding: 0;\n  margin: 0;\n  color: #aaaaaa;\n}\n.item-row__delete:hover {\n  color: #000000;\n}\n.item-row__delete-icon {\n  width: 12px;\n}\n\n.app-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 24px;\n  border: 1px solid rgba(238, 238, 238, 0.9333333333);\n  border-bottom-width: 2px;\n  padding: 20px 32px;\n  font-weight: 500;\n  font-size: 24px;\n}\n.app-button:hover {\n  border-bottom-width: 1px;\n  transform: translateY(1px);\n}\n.app-button__img {\n  width: 80px;\n  height: 80px;\n  object-fit: cover;\n}\n\nh1.heading {\n  font-size: 32px;\n  font-weight: 600;\n}\n\nh2.heading {\n  font-size: 24px;\n  font-weight: 600;\n}\n\nh3.heading {\n  font-size: 20px;\n  font-weight: 600;\n}\n\nh4.heading {\n  font-size: 18px;\n  font-weight: 600;\n}\n\nh5.heading {\n  font-size: 16px;\n  font-weight: 600;\n}\n\nh6.heading {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.file-input {\n  display: flex;\n}\n.file-input__input {\n  opacity: 0;\n  width: 0.1px;\n  height: 0.1px;\n  position: absolute;\n}\n.file-input__label {\n  cursor: pointer;\n  flex: 1;\n  border: 1px dashed #ddd;\n  color: #333;\n  border-radius: 8px;\n  text-align: center;\n  height: 75px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.spinner {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  border: 3px solid #000000;\n  border-bottom: 3px solid transparent;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.modal-form__store-inputs {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n}\n.modal-form__store-inputs > div {\n  flex: 1;\n}\n.modal-form__button {\n  padding: 8px 16px;\n  border: 1px solid #eee;\n  border-radius: 8px;\n}\n\n.are-you-sure-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.are-you-sure-modal__buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.home-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.home-page__intro-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.home-page__header {\n  font-size: 32px;\n  font-weight: 600;\n}\n.home-page__paragraph {\n  font-size: 20px;\n  line-height: 125%;\n  max-width: 600px;\n}\n.home-page__apps-container {\n  border-top: 1px solid #eee;\n  padding-block: 24px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n}\n.home-page__button {\n  border: 1px solid rgba(238, 238, 238, 0.9333333333);\n  border-bottom-width: 2px;\n  padding: 20px 32px;\n  font-weight: 500;\n  font-size: 24px;\n}\n.home-page__button:hover {\n  border-bottom-width: 1px;\n  transform: translateY(1px);\n}\n\n.app-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.app-page__intro-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.app-page__header {\n  font-size: 32px;\n  font-weight: 600;\n}\n.app-page__sub-header {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n.app-page__paragraph {\n  font-size: 20px;\n  line-height: 125%;\n  max-width: 600px;\n}\n.app-page__how-to-install {\n  font-weight: 600;\n  text-decoration: underline;\n}\n.app-page__grid {\n  padding-block: 24px;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 32px;\n}\n@media (min-width: 768px) {\n  .app-page__grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n.app-page__sub-versions {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.app-page__apps-container {\n  border-top: 1px solid #eee;\n  display: flex;\n  gap: 24px;\n}\n.app-page__button {\n  border: 1px solid rgba(238, 238, 238, 0.9333333333);\n  border-bottom-width: 2px;\n  padding: 20px 32px;\n  font-weight: 500;\n  font-size: 24px;\n}\n.app-page__button:hover {\n  border-bottom-width: 1px;\n  transform: translateY(1px);\n}\n.app-page__lastest {\n  background-color: #0055ff !important;\n}\n.app-page__version-button {\n  color: #0055ff;\n  font-weight: 500;\n  text-decoration: underline;\n}\n.app-page__app-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n.app-page__list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.admin-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 32px;\n}\n\n.admin-user-form {\n  padding: 24px;\n  border: 1px solid #eee;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 400px;\n}\n\n.how-to-install {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.how-to-install__link-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.how-to-install__link {\n  color: #0055ff;\n  text-decoration: underline;\n}",".backdrop {\n  position: fixed;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  inset: 0;\n\n  width: 100%;\n  height: 100vh;\n  display: block;\n}\n\n.modal {\n  position: fixed;\n\n  background-color: #ffffff;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n  border-radius: 8px;\n\n  max-height: calc(100vh - 8px);\n\n  min-width: 400px;\n  max-width: 600px;\n  overflow: auto;\n\n  padding: 32px 24px;\n\n  &__close {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n  }\n}\n",".item-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 4px 16px;\n\n  &:hover {\n    background-color: #f5f5f5;\n  }\n\n  &__links-container{\n    display: flex;\n    gap: 16px;\n  }\n\n  &__link {\n    color: #0055ff;\n    font-weight: 500;\n    text-decoration: underline;\n  }\n\n  &__delete {\n    border:0;\n    padding:0;\n    margin:0;\n\n    color: #aaaaaa;\n\n    &:hover {\n      color: #000000;\n    }\n  }\n\n  &__delete-icon {\n    width: 12px;\n  }\n}\n",".app-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 24px;\n\n  border: 1px solid #eeee;\n  border-bottom-width: 2px;\n  padding: 20px 32px;\n  font-weight: 500;\n  font-size: 24px;\n\n  &:hover {\n    border-bottom-width: 1px;\n    transform: translateY(1px);\n  }\n\n  &__img {\n    width: 80px;\n    height: 80px;\n    object-fit: cover;\n  }\n}\n","h1.heading {\n  font-size: 32px;\n  font-weight: 600;\n}\n\nh2.heading {\n  font-size: 24px;\n  font-weight: 600;\n}\n\nh3.heading {\n  font-size: 20px;\n  font-weight: 600;\n}\n\nh4.heading {\n  font-size: 18px;\n  font-weight: 600;\n}\n\nh5.heading {\n  font-size: 16px;\n  font-weight: 600;\n}\n\nh6.heading {\n  font-size: 14px;\n  font-weight: 600;\n}\n",".file-input {\n  display: flex;\n\n  &__input {\n    opacity: 0;\n    width: 0.1px;\n    height: 0.1px;\n    position: absolute;\n  }\n\n  &__label {\n    cursor: pointer;\n\n    flex: 1;\n    border: 1px dashed #ddd;\n    color: #333;\n    border-radius: 8px;\n    text-align: center;\n    height: 75px;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__file-name {\n  }\n}\n",".spinner {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  border: 3px solid #000000;\n  border-bottom: 3px solid transparent;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n",".modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  &__store-inputs {\n    display: flex;\n    align-items: flex-end;\n    gap: 8px;\n\n    & > div {\n      flex: 1;\n    }\n  }\n\n  &__button {\n    padding: 8px 16px;\n    border: 1px solid #eee;\n    border-radius: 8px;\n  }\n}\n",".are-you-sure-modal {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    &__buttons {\n        display: flex;\n        justify-content: flex-end;\n        gap: 8px;\n    }\n}",".home-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  &__intro-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__header {\n    font-size: 32px;\n    font-weight: 600;\n  }\n\n  &__paragraph {\n    font-size: 20px;\n    line-height: 125%;\n    max-width: 600px;\n  }\n\n  &__apps-container {\n    border-top: 1px solid #eee;\n    padding-block: 24px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 24px;\n  }\n\n  &__button {\n    border: 1px solid #eeee;\n    border-bottom-width: 2px;\n    padding: 20px 32px;\n    font-weight: 500;\n    font-size: 24px;\n\n    &:hover {\n      border-bottom-width: 1px;\n      transform: translateY(1px);\n    }\n  }\n}\n",".app-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  &__intro-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__header {\n    font-size: 32px;\n    font-weight: 600;\n  }\n\n  &__sub-header {\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 8px;\n  }\n\n  &__paragraph {\n    font-size: 20px;\n    line-height: 125%;\n    max-width: 600px;\n  }\n\n  &__how-to-install {\n    font-weight: 600;\n    text-decoration: underline;\n  }\n\n  &__grid {\n    padding-block: 24px;\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 32px;\n\n    @media (min-width: 768px) {\n      grid-template-columns: 1fr 1fr;\n    }\n  }\n\n  &__sub-versions {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  &__apps-container {\n    border-top: 1px solid #eee;\n    display: flex;\n    // flex-wrap: wrap;\n    gap: 24px;\n  }\n\n  &__button {\n    border: 1px solid #eeee;\n    border-bottom-width: 2px;\n    padding: 20px 32px;\n    font-weight: 500;\n    font-size: 24px;\n\n    &:hover {\n      border-bottom-width: 1px;\n      transform: translateY(1px);\n    }\n  }\n\n  &__lastest {\n    background-color: #0055ff !important;\n  }\n\n  &__version-button {\n    color: #0055ff;\n    font-weight: 500;\n    text-decoration: underline;\n  }\n\n  &__app-list {\n    display: flex;\n    flex-direction: column;\n    // align-items: flex-start;\n    gap: 16px;\n    width: 100%;\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n}\n",".admin-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 32px;\n}\n.admin-user-form {\n  padding: 24px;\n  border: 1px solid #eee;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 400px;\n}\n",".how-to-install {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  &__link-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__link {\n    color: #0055ff;\n    text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
